import { render, staticRenderFns } from "./deanPagination.vue?vue&type=template&id=08a5fe92&scoped=true"
import script from "./deanPagination.vue?vue&type=script&lang=ts"
export * from "./deanPagination.vue?vue&type=script&lang=ts"
import style0 from "./deanPagination.vue?vue&type=style&index=0&id=08a5fe92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5fe92",
  null
  
)

export default component.exports